import { ComponentProps } from 'react'

import { AlertDialog } from '@/shared/ui'

type Props = Omit<ComponentProps<typeof AlertDialog>, 'title' | 'content'>

export const InProgressContractDialog = (props: Props) => {
  return (
    <AlertDialog
      {...props}
      title="이미 계약이 진행 중인 방입니다"
      content="진행 중인 계약 현황을 확인해 주세요."
    />
  )
}
